export const GET_LECTURES = 'GET_LECTURES';
export const GET_STUDENTS = 'GET_STUDENTS';
export const GET_CHAT = 'GET_CHAT';
export const POST_CHAT = 'POST_CHAT';
export const GET_MESSAGES = 'GET_MESSAGES';
export const POST_MESSAGE = 'POST_MESSAGE';
